import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const heroSlides = [
  {
    category: "K-POP 아이돌",
    categoryIcon: "ri-music-2-line",
    headline: "SEOL의 벚꽃 뮤직비디오",
    sub: "AI로 아이돌 뮤직비디오 신과 안무를 직접 제작하세요",
    bg: "https://public.readdy.ai/ai/img_res/25d998910bc84c83ff7a86ada25b1a5d.jpg",
    accent: "#ff6eb4",
    badge: "뮤직비디오 신 제작",
    badgeIcon: "ri-film-line",
    stats: [
      { icon: "ri-film-line", value: "14만+", label: "뮤직비디오 신" },
      { icon: "ri-music-2-line", value: "8만+", label: "안무 영상" },
      { icon: "ri-user-heart-line", value: "52만+", label: "참여 팬" },
    ],
  },
  {
    category: "드라마 제작사",
    categoryIcon: "ri-tv-2-line",
    headline: "드라마 명장면을 함께 만들어요",
    sub: "인기 드라마 IP로 스핀오프 신과 OST 영상을 AI로 제작하세요",
    bg: "https://readdy.ai/api/search-image?query=korean%20drama%20filming%20set%2C%20cinematic%20lighting%2C%20actors%20in%20emotional%20scene%2C%20professional%20film%20crew%2C%20ultra%20wide%20panoramic%20shot%2C%20dramatic%20warm%20golden%20tones%2C%20atmospheric%20production&width=1400&height=700&seq=drama-hero-bg-001&orientation=landscape",
    accent: "#3d9be9",
    badge: "드라마 신 제작",
    badgeIcon: "ri-tv-2-line",
    stats: [
      { icon: "ri-tv-2-line", value: "9만+", label: "드라마 신 제작" },
      { icon: "ri-clapperboard-line", value: "3.2만+", label: "스핀오프 영상" },
      { icon: "ri-user-heart-line", value: "28만+", label: "드라마 팬" },
    ],
  },
  {
    category: "영화 제작사",
    categoryIcon: "ri-movie-2-line",
    headline: "영화 포스터와 예고편을 직접",
    sub: "영화 IP로 포스터, 예고편 신, 명장면을 AI로 제작하세요",
    bg: "https://readdy.ai/api/search-image?query=korean%20movie%20film%20set%2C%20cinematic%20wide%20shot%2C%20dramatic%20lighting%2C%20professional%20film%20production%2C%20epic%20panoramic%20composition%2C%20dark%20atmospheric%20tones%2C%20director%20and%20crew%20silhouette&width=1400&height=700&seq=film-hero-bg-001&orientation=landscape",
    accent: "#e84545",
    badge: "영화 포스터 & 예고편",
    badgeIcon: "ri-movie-2-line",
    stats: [
      { icon: "ri-movie-2-line", value: "6만+", label: "영화 포스터" },
      { icon: "ri-play-circle-line", value: "4만+", label: "예고편 신" },
      { icon: "ri-user-heart-line", value: "19만+", label: "영화 팬" },
    ],
  },
  {
    category: "웹툰 스튜디오",
    categoryIcon: "ri-book-open-line",
    headline: "웹툰 캐릭터를 영상으로 살려내요",
    sub: "웹툰 IP로 실사 영상화, 애니메이션 신, 캐릭터 포스터를 만드세요",
    bg: "https://readdy.ai/api/search-image?query=webtoon%20animation%20production%20studio%2C%20colorful%20character%20designs%2C%20vibrant%20digital%20art%20workspace%2C%20ultra%20wide%20panoramic%20composition%2C%20creative%20atmosphere%2C%20orange%20and%20teal%20color%20scheme%2C%20dynamic%20energy&width=1400&height=700&seq=webtoon-hero-bg-001&orientation=landscape",
    accent: "#ff8c42",
    badge: "웹툰 실사 영상화",
    badgeIcon: "ri-book-open-line",
    stats: [
      { icon: "ri-book-open-line", value: "5만+", label: "웹툰 실사화" },
      { icon: "ri-image-line", value: "7만+", label: "캐릭터 포스터" },
      { icon: "ri-user-heart-line", value: "15만+", label: "웹툰 팬" },
    ],
  },
];

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setAnimating(true);
      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % heroSlides.length);
        setAnimating(false);
      }, 400);
    }, 5500);
    return () => clearInterval(timer);
  }, []);

  const slide = heroSlides[current];

  const goTo = (idx: number) => {
    if (idx === current) return;
    setAnimating(true);
    setTimeout(() => {
      setCurrent(idx);
      setAnimating(false);
    }, 300);
  };

  return (
    <section className="relative w-full h-[580px] md:h-[700px] overflow-hidden">
      {/* Background */}
      <img
        src={slide.bg}
        alt="Hero Background"
        className={`absolute inset-0 w-full h-full object-cover object-top transition-opacity duration-500 ${animating ? "opacity-0" : "opacity-100"}`}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-[#0a0a0f]" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-transparent to-black/50" />

      {/* Floating particles */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 rounded-full opacity-40 animate-pulse"
            style={{
              background: slide.accent,
              left: `${15 + i * 15}%`,
              top: `${20 + (i % 3) * 20}%`,
              animationDelay: `${i * 0.5}s`,
              animationDuration: `${2 + i * 0.3}s`,
            }}
          />
        ))}
      </div>

      {/* Content */}
      <div
        className={`relative z-10 h-full flex flex-col items-center justify-center text-center px-6 transition-all duration-500 w-full ${
          animating ? "opacity-0 translate-y-4" : "opacity-100 translate-y-0"
        }`}
      >
        {/* Headline */}
        <h1 className="text-4xl md:text-6xl font-black text-white mb-4 leading-tight tracking-tight">
          {slide.headline}
        </h1>
        <p className="text-white/70 text-lg md:text-xl mb-8 font-light max-w-xl">{slide.sub}</p>

        {/* CTA Buttons */}
        <div className="flex items-center gap-4 flex-wrap justify-center">
          <Link
            to="/quests"
            className="px-8 py-3.5 rounded-full font-bold text-sm text-white whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity flex items-center gap-2"
            style={{ background: `linear-gradient(135deg, ${slide.accent}, ${slide.accent}99)` }}
          >
            <i className="ri-film-line" />
            캠페인 참여하기
          </Link>
        </div>

        {/* Slide Indicators */}
        <div className="flex items-center gap-2 mt-10">
          {heroSlides.map((s, idx) => (
            <button
              key={idx}
              onClick={() => goTo(idx)}
              className={`rounded-full transition-all duration-300 cursor-pointer ${
                idx === current ? "w-8 h-2" : "w-2 h-2 bg-white/30 hover:bg-white/50"
              }`}
              style={idx === current ? { background: slide.accent } : {}}
            />
          ))}
        </div>
      </div>

      {/* Scroll hint */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 animate-bounce">
        <i className="ri-arrow-down-line text-white/30 text-lg" />
      </div>
    </section>
  );
}
